import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { AuthShell, GoogleButton } from "@/pages/authShared";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(params.get("error") === "google" ? "Google sign-in failed. Try again." : "");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try { await login(email, password); toast.success("Welcome back!"); navigate("/account"); }
    catch (e) { setErr(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Sign in" subtitle="Access your account, orders and digital library.">
      <form onSubmit={submit} className="space-y-4">
        <div><Label className="text-xs">Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" /></div>
        <div>
          <div className="flex justify-between items-center"><Label className="text-xs">Password</Label>
            <Link to="/forgot-password" className="text-xs text-teal" data-testid="forgot-link">Forgot password?</Link></div>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
        </div>
        {err && <p className="text-sm text-red-600" data-testid="login-error">{err}</p>}
        <Button type="submit" className="w-full bg-teal hover:bg-teal-dark text-white" disabled={loading} data-testid="login-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
        </Button>
      </form>
      <div className="flex items-center gap-3 my-4"><div className="flex-1 h-px bg-slate-200" /><span className="text-xs text-slate-400">or</span><div className="flex-1 h-px bg-slate-200" /></div>
      <GoogleButton />
      <p className="text-sm text-slate-500 mt-6 text-center">No account? <Link to="/register" className="text-teal font-medium" data-testid="to-register">Create one</Link></p>
    </AuthShell>
  );
}
